<ng-container *ngIf="moduleActive">
  <pt-details-layout
    [showNoData]="!securityToolType"
    [title]="'LABELS.VULNERABILITY' | translate">

    <ng-container titleSuffix>
      <button (click)="configureSecurityToolType()" *ngIf="securityToolType"
              class="btn btn-outline-secondary btn-sm ms-2">
        <pt-icon [key]='IconBuild' [size]="14"></pt-icon>
      </button>

      <button (click)="removeSecurityToolType()" *ngIf="securityToolType" class="btn btn-outline-danger btn-sm ms-2">
        <pt-icon [key]='IconTrash' [size]="14"></pt-icon>
      </button>
    </ng-container>

    <ng-container noDataSuffix>
      <div class="alert alert-info p-2" style="margin: 0 -15px 0 -4px !important">
        {{ 'MESSAGE.VULNERABILITY' | translate }}
        <span (click)="configureSecurityToolType()" class="details-link">{{ "LABELS.CONFIGURE" | translate }}</span>
      </div>
    </ng-container>

    <ng-container body>

      <pt-details-application-vulnerability-cvs-severity
        *ngIf="securityToolType"
        [cveSeverity]="application?.latestScan?.cveSeverity"
        class="w-100">
      </pt-details-application-vulnerability-cvs-severity>

<!--      [threatEvalLabels]="application?.latestAudit?.impactMetricsLabels"-->

      <div *ngIf="securityToolType" class="app-vulnerability-container">
        <div class='attribute'>
          <div class='key'>{{ 'PAGE.APPLICATIONS.DETAILS.LATEST_SCAN' | translate }}</div>
          <div class="value">{{
              application?.latestScan?.scanAt | localizedDate: {
                pattern: dateFormat,
                defaultValue: ND
              }
            }}
          </div>
        </div>

        <div class='attribute'>
          <div *ngIf="application?.latestAudit?.createdAt"
               class='key'>{{ 'PAGE.APPLICATIONS.DETAILS.NEW_VULNERABILITIES' | translate }}
          </div>
          <div *ngIf="!application?.latestAudit?.createdAt"
               class='key'>{{ 'PAGE.APPLICATIONS.DETAILS.NEW_VULNERABILITIES_NO_AUDIT' | translate }}
          </div>
          <div [class.text-danger]="application.latestScan?.newCve > 0" class="value d-flex align-items-center">
            <pt-icon *ngIf="application.latestScan?.newCve > 0" [key]='IconWarning' [size]="14"></pt-icon>
            {{ application.latestScan?.newCve || '0' }}
          </div>
        </div>

        <div class='attribute'>
          <div class='key'>{{ 'PAGE.APPLICATIONS.DETAILS.LATEST_AUDIT' | translate }}</div>
          <div *ngIf="application?.latestAudit?.createdAt" class="value">
            {{ application?.latestAudit?.createdAt | localizedDate: {pattern: dateFormat, defaultValue: ND} }}
            (<a (click)='navigateToUser(application?.latestAudit?.authorId)'
                class='btn btn-link btn-attribute text-link'>
            {{ application?.latestAudit?.authorUsername }}
          </a>)
          </div>
          <div *ngIf="!application?.latestAudit?.createdAt" class="value">
            -
          </div>
        </div>


      </div>
    </ng-container>
  </pt-details-layout>
</ng-container>

<ng-template #errorDialog>
  <div class="modal-header">
    <div class="h4 modal-title" [innerHTML]="'TITLE.MISSING_CVE' | translate"></div>
  </div>
  <div class="modal-body" style="margin-right: 4px;">
    <div [innerHTML]="errorMessage | translate"></div>
  </div>
  <div class="modal-footer">
    <div class="w-100 d-flex justify-content-end">

      <button (click)="closeErrorDialog()" class="btn btn-sm btn-outline-secondary">
        {{ "BUTTON.CLOSE" | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #dialog>
  <div class="modal-header">
    <div class="h4 modal-title">{{ "LABELS.CONFIGURATION" | translate }}</div>
  </div>

  <div class="modal-body" style="margin-right: 4px;">
    <p>{{ "MESSAGE.SECURITY_TOOL_TYPE_DIALOG" | translate }}</p>
    <form [formGroup]="formGroup">
      <div class="form-check">
        <input [value]="Type.VENDOR_PRODUCT"
               class="form-check-input"
               formControlName="option"
               id="securityToolRadio3"
               type="radio">
        <label class="form-check-label fw-bold" for="securityToolRadio3">
          {{ 'LABELS.SECURITY_TOOL_OPTION_' + Type.VENDOR_PRODUCT  | translate }}
        </label>
        <p>
          {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.VENDOR_PRODUCT  | translate }}
        </p>
      </div>

      <div #collapse="ngbCollapse" [(ngbCollapse)]="isVendorProductCollapsed" [animation]="true">

        <pt-details-security-tool-type-vendor-or-product
          (updateVendorProduct)="updateVendorProduct($event)"
          [version]="currentVersion"
          [product]="currentProduct"
          [vendor]="currentVendor">
        </pt-details-security-tool-type-vendor-or-product>
      </div>

      <div class="form-check">
        <input [value]="Type.CPE"
               class="form-check-input"
               formControlName="option"
               id="securityToolRadio4"
               type="radio">
        <label class="form-check-label fw-bold" for="securityToolRadio4">
          {{ 'LABELS.SECURITY_TOOL_OPTION_' + Type.CPE  | translate }}
        </label>
        <p>
          {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.CPE + '_1'  | translate }}
        </p>
        <p class="mb-0">
          {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.CPE + '_2'  | translate }}
          <a href="https://nvd.nist.gov/products/cpe/search" target='_blank'>https://nvd.nist.gov/ </a>
        </p>
        <p class="text-success">
          {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.CPE + '_3'  | translate }}

        </p>
      </div>

      <div #collapse="ngbCollapse" [(ngbCollapse)]="isCVECollapsed" [animation]="true">
        <div class="cpe">
          <div class="mb-3">
            <form [formGroup]="currentCpeForm">
              <label>
                {{ 'LABELS.CPE' | translate }}
              </label>

              <div class="input-group input-group-sm mb-3">
                <input type="text"
                       [class.is-invalid]='currentCpeForm.invalid'
                       class="form-control"
                       placeholder=""
                       formControlName="cpe">
              </div>
            </form>

          </div>
        </div>
      </div>

      <div class="form-check">
        <input [value]="Type.BOM"
               class="form-check-input"
               formControlName="option"
               id="securityToolRadio2"
               type="radio">
        <label class="form-check-label fw-bold" for="securityToolRadio2">
          {{ 'LABELS.SECURITY_TOOL_OPTION_' + Type.BOM  | translate }}
        </label>
        <p>
          {{ 'MESSAGE.SECURITY_TOOL_OPTION_' + Type.BOM  | translate }}
        </p>
      </div>

      <div #collapse="ngbCollapse" [(ngbCollapse)]="isSupplierCollapsed" [animation]="true">
        <pt-details-security-tool-type-supplier
          (uploadBom)="uploadBom($event)"
          [bomFileErrorMessage]="currentBomFileError"
          [bomFileName]="currentBomFileName">
        </pt-details-security-tool-type-supplier>
      </div>
    </form>

    <ngb-alert *ngIf='isChangeVendorOrProduct'
               [animation]='true'
               [dismissible]='false'
               [type]="'warning'"
               style="margin-left: 20px !important; padding: 2px 5px;">
      {{ 'MESSAGE.SECURITY_TOOL_CHANGE_CONFIGURATION_INFO' | translate }}
    </ngb-alert>
  </div>

  <div class="modal-footer">
    <div class="w-100 d-flex justify-content-end">
      <button (click)="save()"
              [disabled]="invalidForm || loading"
              class="btn btn-sm btn-primary me-2">
        <div class='spinner-border' role='status'
             *ngIf="loading" style="width: 13px; height: 13px; border-width: 2px">
          <span class='visually-hidden'>Loading...</span>
        </div>
        {{ "BUTTON.SAVE" | translate }}
      </button>

      <button (click)="closeDialog()"
              class="btn btn-sm btn-outline-secondary"
              id="{{cancelSecurityToolId}}">
        {{ "BUTTON.CANCEL" | translate }}
      </button>
    </div>
  </div>
</ng-template>

